import Backbone from 'backbone';
import _ from 'underscore';

import { OrderChannelHelper } from '@biteinc/enums';
import { StringHelper } from '@biteinc/helpers';

import { KeyCode } from '../enums/key_code';
import { BrowserHelper } from '../helpers/browser_helper';
import { template } from '../template';

const SELECTED_TAB = 'selected';

app.TabbedView = Backbone.View.extend({
  template: template(
    // prettier-ignore
    '<div id="sidebar-scrim"></div>' +
    '<div id="sidebar-border"></div>' +
    '<div id="sidebar" class="no-user-select">' +
      '<div class="contents"></div>' +
    '</div>' +
    '<div class="component-tabs"></div>',
  ),
  className: 'tabbed-view',

  handleKeyDown(event) {
    if (!this.context) {
      return;
    }
    const modKey = BrowserHelper.isMac() ? event.metaKey : event.ctrlKey;
    if (event.keyCode === KeyCode.KeyK && modKey) {
      event.preventDefault();
      this.openSettingsSearch();
    }
    if (event.which === 27 && this._biteSearchTool) {
      this._biteSearchTool.remove();
      this._biteSearchTool = null;
    }
  },

  openSettingsSearch() {
    if (this._biteSearchTool) {
      return;
    }
    this._biteSearchTool = new app.BiteSearchView({
      context: this.context,
      onRemove: () => {
        this._biteSearchTool = null;
      },
    });
    this._biteSearchTool.render();
    $('body').append(this._biteSearchTool.$el);
    this._biteSearchTool.$el.find('input').focus();
  },

  initialize() {
    this.sidebarElements = [];
    this.tabViews = [];
    this.tabViewsById = {};
    this.hasFooter = false;
    this.mobileMenuVisible = false;

    if (this.context) {
      this._addSearchSettingsLink();
    }

    const self = this;
    $(window).on('resize', this._adjustAppHeight.bind(this));
    $(document).on('keydown', this.handleKeyDown.bind(this));
    window.onbeforeunload = function onbeforeunload() {
      if (!self.selectedTabView.canSuspend()) {
        return 'You have unsaved changes.';
      }
      const topModal = _.last(app.modalManager.modalStack);
      if (topModal && !topModal.canDismissModal()) {
        return 'Your modal has unsaved changes.';
      }
      return undefined; // returning null doesn't work on IE11
    };
  },

  setPageHeader(header) {
    this._header = header;
    header.$('.menu-button').click(() => {
      if (this.mobileMenuVisible) {
        this._hideMobileMenu();
      } else {
        this._showMobileMenu();
      }
    });
  },

  _hideMobileMenu() {
    if (!this.mobileMenuVisible) {
      return;
    }

    this.mobileMenuVisible = false;
    $('body').removeClass('modal-open');
    $('body').css('position', 'relative');
    this.$sidebar.stop().animate({ left: '-100%' }, 500, 'easeInOutExpo');
    this.$sidebarScrim.stop().fadeOut(500, 'easeInOutExpo');
  },

  _showMobileMenu() {
    if (this.mobileMenuVisible) {
      return;
    }

    this.mobileMenuVisible = true;
    $('body').addClass('modal-open');
    $('body').css('position', 'fixed');
    this.$sidebar.stop().animate({ left: '0' }, 500, 'easeInOutExpo');
    this.$sidebarScrim.stop().fadeIn(500, 'easeInOutExpo');
  },

  _adjustAppHeight() {
    const tabHeight = this.$el.height() - 40;
    // 40 is top/bottom margin
    // This magic number is also used in tab_view:_applyHeight
    _.each(this.tabViews, (tabView) => {
      if (tabView.supportsViewportMode) {
        tabView.setHeight(tabHeight);
      }
    });
  },

  addTab(tabView, name, id, index) {
    if (undefined === index) {
      index = -1;
    }

    if (!tabView.suspend) {
      alert(`tabview ${name} does not support suspend`);
    }
    if (!tabView.canSuspend) {
      alert(`tabview ${name} does not support canSuspend`);
    }
    if (!name && tabView.collection) {
      name = StringHelper.toTitleCase(tabView.collection.type());
    }
    if (!id && tabView.collection) {
      id = tabView.collection.type().split(' ').join('-');
    }
    this.tabViews.push(tabView);

    const className = `tab-${id}`;
    this.tabViewsById[id] = tabView;
    tabView.title = name;
    tabView.$el.addClass('component-tab');
    tabView.$el.addClass(className);
    tabView.$el.hide();

    const self = this;
    tabView.$tabTongue = $(`<div class="sb-el tab"><span>${name}</span></div>`);
    tabView.$tabTongue.addClass(className);
    tabView.$tabTongue.click(() => {
      if (self.selectedTabView.canSuspend()) {
        self.router.navigate(id, { trigger: true });
      }
      self._hideMobileMenu();
    });
    if (index >= 0) {
      self.sidebarElements.splice(index, 0, tabView.$tabTongue);
      tabView.$tabTongue.addClass('subtab');
    } else {
      self.sidebarElements.push(tabView.$tabTongue);
    }

    return className;
  },

  buildSubSchemaFromTabId(schema, tabId) {
    return {
      ...schema,
      fields: Object.fromEntries(
        Object.entries(schema.fields).filter(
          ([_fieldName, fieldSchema]) => fieldSchema.tabId === tabId,
        ),
      ),
    };
  },

  addSettingsTab(model, schema, tabName, tabId, DetailsViewClass = app.BaseDetailsView) {
    const subSchema = this.buildSubSchemaFromTabId(schema, tabId);
    const tab = new app.TabView();
    const settingsView = new DetailsViewClass({
      model,
      schema: subSchema,
    });
    tab.setLeftView(settingsView, true);
    this.addTab(tab, tabName, tabId);
    return tab;
  },

  addBottomLinks(showHelpAndReleaseNotes, showChangePassword) {
    const canAccessKor =
      app.sessionUser.isBite() || (app.sessionUser.isAdmin() && app.org?.get('adminCanAccessKor'));
    const canAccessSalesDashboard =
      app.sessionUser.isBite() || app.sessionUser.canGenerateReports();

    if (canAccessKor || canAccessSalesDashboard) {
      this.addSpacer();

      if (app.sessionUser.isBite()) {
        this.addLinkWithHandler('Admin V2', () => {
          window.location.href = '/v2';
        });
      }

      if (canAccessKor && app.org) {
        this.addLinkWithHandler('Org KOR Overview', () => {
          window.open(`/v2/${app.org.get('normalizedName')}/kor`, '_blank');
        });
      }

      if (
        canAccessKor &&
        app.location &&
        OrderChannelHelper.isKorMonitored(app.location.get('orderChannel'))
      ) {
        this.addLinkWithHandler('Location KOR Overview', () => {
          window.open(
            `/v2/${app.org.get('normalizedName')}/${app.location.get('normalizedName')}/kor`,
            '_blank',
          );
        });
      }

      if (canAccessSalesDashboard && app.org) {
        this.addLinkWithHandler('Org Sales Dashboard', () => {
          window.open(`/v2/${app.org.get('normalizedName')}/sales`, '_blank');
        });
      }

      if (canAccessSalesDashboard && app.location) {
        this.addLinkWithHandler('Location Sales Dashboard', () => {
          window.open(
            `/v2/${app.org.get('normalizedName')}/${app.location.get('normalizedName')}/sales`,
            '_blank',
          );
        });
      }

      this.addSpacer();
    }
    if (showHelpAndReleaseNotes) {
      this.addSpacer();
      const basicImg =
        '<img class="icon" src="https://static.bureau.getbite.com/images/icon-help.png" srcset="https://static.bureau.getbite.com/images/icon-help@2x.png 2x">';
      const hoverImg =
        '<img class="icon-hover" src="https://static.bureau.getbite.com/images/icon-help-hover.png" srcset="https://static.bureau.getbite.com/images/icon-help-hover@2x.png 2x">';
      const helpLink = `${basicImg}${hoverImg} Help`;
      this.addLinkWithHandler(helpLink, () => {
        window.open('https://getbite.zendesk.com/hc/en-us', '_blank');
      });
    }

    this._addWhatsNewLink();

    this.addSpacer();

    this.addSmallText(`Logged in as ${app.sessionUser.get('username')}`);

    if (showChangePassword) {
      this.addLinkWithHandler('Your Profile', () => {
        const detailsView = new app.UserDetailsView({
          model: app.sessionUser,
          schema: app.User.Schema(),
        });
        app.modalManager.showModalWithView(detailsView);
      });
    }

    this.addLinkWithHandler('Log Out', () => {
      const callback = () => {
        window.location.href = '/';
      };
      app.postRequest('/api/auth/logout', null, callback, callback);
    });

    this.addFooter(`Copyright ${new Date().getFullYear()} Bite Inc`);
  },

  _addWhatsNewLink() {
    // Bite-gated for the initial What's New rollout; widen to all users later.
    if (!app.sessionUser.isBite()) {
      return;
    }
    // 📬 = unread mail; back to the plain stars icon once the latest post
    // was viewed.
    const $link = $(
      '<button type="button" class="sb-el link whats-new-link"><span class="wn-mail" aria-hidden="true">📬</span><span>What’s New</span></button>',
    );
    const showSeenIcon = () => {
      $link.find('.wn-mail').replaceWith('<i class="bi bi-stars" aria-hidden="true"></i>');
    };
    $link.hide();
    $link.click(() => {
      app.WhatsNewModal.fetchPayload((payload) => {
        const month = payload?.months[0];
        if (!month) {
          return;
        }
        app.modalManager.showModalWithView(new app.WhatsNewModal({ month }));
        // The memoized payload's lastSeenAnnouncementId goes stale after the
        // first markSeen, so key repeat opens off the link's own state.
        if ($link.hasClass('has-new') && payload.latestAnnouncementId) {
          app.WhatsNewModal.markSeen(payload.latestAnnouncementId, (wasMarkedSeen) => {
            if (wasMarkedSeen) {
              $link.removeClass('has-new');
              showSeenIcon();
            }
          });
        }
      });
    });
    this.sidebarElements.push($link);

    // The link stays hidden until the payload resolves, then appears in its
    // final state — bold with the mailbox when the newest post is unseen.
    app.WhatsNewModal.fetchPayload((payload) => {
      if (!payload?.months.length) {
        return;
      }
      if (
        payload.latestAnnouncementId &&
        payload.latestAnnouncementId !== payload.lastSeenAnnouncementId
      ) {
        $link.addClass('has-new');
      } else {
        showSeenIcon();
      }
      $link.fadeIn(200);
    });
  },

  _addSearchSettingsLink() {
    const shortcutHtml = BrowserHelper.isMobile()
      ? ''
      : `<span class="shortcut">${BrowserHelper.isMac() ? '⌘K' : 'Ctrl+K'}</span>`;
    const $link = $(
      `<div class="sb-el link search-settings"><i class="bi bi-search" aria-hidden="true"></i><span>Search Settings</span>${shortcutHtml}</div>`,
    );
    $link.click(() => {
      this._hideMobileMenu();
      this.openSettingsSearch();
    });
    this.sidebarElements.push($link);
  },

  addSpacer() {
    this.sidebarElements.push($('<div class="sb-el spacer"></div>'));
  },

  addSeparatorWithTitle(title) {
    this.sidebarElements.push($(`<div class="sb-el separator">${title}</div>`));
  },

  addSmallText(text) {
    this.sidebarElements.push($(`<div class="sb-el small-text">${text}</div>`));
  },

  addLinkWithHandler(html, handler) {
    const $link = $(`<div class="sb-el link">${html}</div>`);
    $link.click(handler);
    this.sidebarElements.push($link);
  },

  addFooter(text) {
    this.hasFooter = true;
    this.sidebarElements.push($(`<div class="sb-el footer">${text}</div>`));
  },

  getSelectedTabView() {
    return this.selectedTabView;
  },

  routeTo(tabId, param) {
    const self = this;
    if ('default' !== tabId && (param || '').length > 1) {
      if ('menus/' === tabId) {
        if (app.menuStructureList.hasBeenFetched()) {
          const structure = app.menuStructureList.get(param);
          if (structure) {
            tabId = `menus/${param}`;
            if (!self.tabViewsById[tabId]) {
              const menuPagesView = new app.MenuPagesTabView({
                model: structure,
              });
              menuPagesView.subTabId = tabId;
              self.addTab(menuPagesView, structure.get('name'), tabId, 1);
              menuPagesView.$tabTongue.insertAfter(self.sidebarElements[0]);
              menuPagesView.$el.insertAfter(self.tabViews[0].$el);
              self._adjustAppHeight();
            }

            param = null;
          } else {
            tabId = 'menus';
          }
        } else {
          self.listenToOnce(app.menuStructureList, 'reset', () => {
            self.routeTo(tabId, param);
          });
          return;
        }
      } else {
        tabId = tabId.substr(0, tabId.length - 1);
      }
    }

    if ('nada' === tabId || 'default' === tabId) {
      tabId = this.defaultTabId;

      if (param?.startsWith('kiosk-orders')) {
        // We renamed the tab to remove any reference to kiosks.
        // To make sure old links still work, we need to rewrite the tabId.
        tabId = 'orders';
        param = param.substr('kiosk-orders'.length + 1);
      } else {
        // If there was no tab specified then the param makes no sense
        param = null;
      }
    }
    self.selectTabById(tabId, param);
  },

  selectTabById(tabId, param) {
    if (!this.tabViewsById[tabId]) {
      tabId = _.first(_.keys(this.tabViewsById));
    }

    const prevTabView = this.selectedTabView;
    const curTabView = this.tabViewsById[tabId];

    if (prevTabView !== curTabView) {
      if (prevTabView) {
        prevTabView.suspend();
      }
      this.selectedTabView = curTabView;
      curTabView.render();
      $('body').toggleClass('no-scroll', curTabView.supportsViewportMode);
    }

    // Update url (browser history) after suspending the old tab
    this._updateUrlTo(tabId, param);

    if (prevTabView) {
      prevTabView.$tabTongue.removeClass(SELECTED_TAB);
      prevTabView.$el.hide();

      if (prevTabView.subTabId) {
        delete this.tabViewsById[prevTabView.subTabId];
        prevTabView.destroy();
        prevTabView.$tabTongue.remove();
        prevTabView.$el.remove();
        for (let i = this.sidebarElements.length - 1; i >= 0; i--) {
          if (this.sidebarElements[i] === prevTabView.$tabTongue) {
            this.sidebarElements.splice(i, 1);
            break;
          }
        }
        for (let j = this.tabViews.length - 1; j >= 0; j--) {
          if (this.tabViews[j] === prevTabView) {
            this.tabViews.splice(j, 1);
            break;
          }
        }
      }
    }

    if (curTabView) {
      curTabView.$tabTongue.addClass(SELECTED_TAB);
      curTabView.$el.show();
      if (param) {
        curTabView.setSelectedElementId(param);
      }

      // Scroll the sidebar tab into view
      const tabY = curTabView.$tabTongue.position().top;
      const tabMaxY = tabY + curTabView.$tabTongue.outerHeight();
      const viewportY = this.$sidebar.scrollTop();
      const viewportMaxY = viewportY + this.$sidebar.outerHeight();
      let scrollTop = -1;
      if (viewportY > tabY - 60) {
        scrollTop = Math.max(0, tabY - 60);
      } else if (viewportMaxY < tabMaxY + 60) {
        scrollTop = Math.max(0, tabMaxY + 60 - this.$sidebar.outerHeight());
      }

      this.$sidebar.stop();
      if (scrollTop >= 0) {
        this.$sidebar.animate({ scrollTop }, 600);
      }
    }
  },

  _updateUrlTo(tabId, param) {
    if ((param || '').length) {
      tabId += `/${param}`;
    }

    if (this._header) {
      this._header.updateLocationUrlsWithTabId(tabId);
    }
    this.router.navigate(tabId, { trigger: false, replace: true });
  },

  _getTabIdForTabView(tabView) {
    const self = this;
    return _.find(_.keys(this.tabViewsById), (tabId) => {
      return self.tabViewsById[tabId] === tabView;
    });
  },

  updateUrlParam(param) {
    const tabId = this._getTabIdForTabView(this.selectedTabView);
    this._updateUrlTo(tabId, param);
  },

  render() {
    this.$el.html(this.template());

    this.$sidebar = this.$('#sidebar');
    this.$sidebarList = this.$sidebar.find('.contents');
    this.$sidebarScrim = this.$('#sidebar-scrim');
    this.$tabViewContainer = this.$('div.component-tabs');

    if (this.hasFooter) {
      this.$sidebar.addClass('with-footer');
    }

    this.$sidebarScrim.on('touchstart', this._hideMobileMenu.bind(this));

    _.each(this.sidebarElements, ($el) => {
      this.$sidebarList.append($el);
    });

    _.each(this.tabViews, (tabView) => {
      this.$tabViewContainer.append(tabView.$el);
    });

    this._adjustAppHeight();

    const routes = {};
    let defaultTabId = null;
    _.each(this.tabViewsById, (view, tabId) => {
      routes[tabId] = tabId;
      if (_.keys(routes).length === 1) {
        defaultTabId = tabId;
        routes[''] = 'nada';
      }

      if (view.supportsElementRouting) {
        routes[`${tabId}/:elementId`] = `${tabId}/`;
      }
    });
    routes['*default'] = 'default';
    this.defaultTabId = this.defaultTabId || defaultTabId;

    const AppRouter = Backbone.Router.extend({
      routes,
    });
    this.router = new AppRouter();
    app.router = this.router;
    _.each(routes, (tabId) => {
      this.router.on(`route:${tabId}`, (param) => {
        this.routeTo(tabId, param);
      });
    });

    Backbone.history.start();

    return this;
  },
});
